import { useState, useEffect, useCallback } from 'react'

export const OPEN_COMMAND_PALETTE_EVENT = 'open-command-palette'

export const useCommandPalette = () => {
  const [isOpen, setIsOpen] = useState(false)

  const open = useCallback(() => setIsOpen(true), [])
  const close = useCallback(() => setIsOpen(false), [])

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      const modifier = e.metaKey || e.ctrlKey
      const isCmdK = modifier && !e.shiftKey && e.key.toLowerCase() === 'k'
      const isCmdShiftF = modifier && e.shiftKey && e.key.toLowerCase() === 'f'

      if (isCmdK || isCmdShiftF) {
        e.preventDefault()
        e.stopPropagation()
        setIsOpen(prev => !prev)
      }
    }

    const handleOpenEvent = () => setIsOpen(true)

    document.addEventListener('keydown', handleKeyDown, true)
    document.addEventListener(OPEN_COMMAND_PALETTE_EVENT, handleOpenEvent)

    return () => {
      document.removeEventListener('keydown', handleKeyDown, true)
      document.removeEventListener(OPEN_COMMAND_PALETTE_EVENT, handleOpenEvent)
    }
  }, [])

  return { isOpen, open, close }
}
